import { TopicsBoard } from '@/components/controls/TopicsBoard'
import '@/styles/controls.css'

/**
 * Topics (/app/feed/topics). A feed control: Brian's after/settings-topics.html
 * v3.1. Comes back to Feed controls. `?pill=<id>` opens that keyword's sheet.
 */
export function TopicsPage() {
  return <TopicsBoard />
}
